import { createLogger } from '../../utils/logger';

const logger = createLogger('parseWipayCallback');

/**
 * Parse URL search string into a plain object.
 * @param {string} search
 */
export function parseQueryParams(search) {
  const params = new URLSearchParams(search);
  const obj = {};
  for (const [key, value] of params.entries()) {
    obj[key] = value;
  }
  return obj;
}

/**
 * Parse WiPay `data` query param (URL-encoded JSON, optionally wrapped in quotes).
 * @param {string|undefined} dataParam
 * @returns {Record<string, unknown>}
 */
export function parseWipayDataQueryParam(dataParam) {
  if (!dataParam || typeof dataParam !== 'string') {
    return {};
  }
  try {
    let dataString = decodeURIComponent(dataParam);
    if (dataString.startsWith('"') && dataString.endsWith('"')) {
      dataString = dataString.slice(1, -1);
    }
    dataString = dataString.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    return JSON.parse(dataString);
  } catch (e) {
    logger.warn('[parseWipayDataQueryParam] Failed to parse data param:', e);
    return {};
  }
}
